export enum Quest {
  EMAIL = 'email',
  PASSWORD = 'password',
  WHY_HERE = 'whyHere',
  Q_INQUIRY = 'questionnaireInquiry',
  NAME = 'name',
  AGE = 'age',
}
